import { createAction } from '@reduxjs/toolkit';
import { nameSpace } from '../Modules/nameSpace';

// These action are specific page based actions
// These action are used to call saga and perform some task

const assignEventToPersonnel = createAction(
  `${nameSpace}/assignEventToPersonnel`,
);
const updateDistribution = createAction(`${nameSpace}/updateDistribution`);

const submitEventForReview = createAction(`${nameSpace}/submitEventForReview`);
const setInappropriate = createAction(`${nameSpace}/setInappropriate`);
const approveEvent = createAction(`${nameSpace}/approveEvent`);
const rejectEvent = createAction(`${nameSpace}/rejectEvent`);
const printEventList = createAction(`${nameSpace}/listPDF`);
const printEvent = createAction(`${nameSpace}/detailPDF`);

export default {
  assignEventToPersonnel,
  updateDistribution,
  submitEventForReview,
  setInappropriate,
  approveEvent,
  rejectEvent,
  printEvent,
  printEventList,
};
